import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import "jspdf-autotable";
import logo from "../../assets/logo-cloud.png";
export default async function downloadPDF(
  oem,
  product,
  environment,
  apiType,
  duration,
  apiUrl,
  accessToken,
  oemDescription,
  environmentDescription,
  productDescription,
  oemDetails,
  productDetails,
  environmentDetails,
  endpointTypeDetails
) {
  const filters = `Environment: ${environmentDetails[environment]}, API Type: ${apiType}, OEM: ${oem}, Product: ${product}`;
  console.log(productDescription)
  const data = await getMainpageData(
    oem,
    product,
    environment,
    apiType,
    duration,
    apiUrl,
    accessToken
  );
  if (!data.overallResults || data.overallResults.length === 0) {
    throw new Error("No endpoint data available for the selected filters and duration. Please try different filter combinations or check if endpoints are configured for this selection.");
  }
  const totalFailures = data.overallResults.reduce((sum, endpoint) => {
    return sum + endpoint.downRequests;
  }, 0);
  const runningEndpoints = data.overallResults.filter(
    (item) => item.latestStatus === "Running"
  ).length;
  const pdf = new jsPDF("p", "mm", "a4");
  const COLORS = {
    primary: "#003366",
    accent: "#FFD770",
    backgrounds: {
      page: "#F5F8FC",
      card: "#FFFFFF",
      highlight: "#F0F5FF",
      accent: "#FFF9E6",
    },
    text: {
      primary: "#1F2937",
      secondary: "#6B7280",
      muted: "#9CA3AF",
    },
  };
  const overallAvailability =
    parseFloat(data.overallAvailability).toFixed(2) + "%";
  // Set background color for header
  pdf.setFillColor(...hexToRGB(COLORS.primary));
  pdf.rect(0, 0, pdf.internal.pageSize.width, 50, "F");

  // Add logo (assuming a base64 encoded logo - replace with your actual logo)
  const img = new Image();
  img.src = logo;

  // Wait for the image to load before adding it to the PDF
  await new Promise((resolve) => {
    img.onload = resolve;
  });

  // Add logo with proper dimensions
  const logoWidth = 30;
  const logoHeight = 30;
  pdf.addImage(img, "PNG", 20, 10, logoWidth, logoHeight);

  // Title styling - moved to accommodate logo
  pdf.setTextColor(247, 248, 253); // #003366
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(24);
  pdf.text("Endpoint Monitoring Report", 60, 30);

  // Reset font for content
  pdf.setFont("helvetica", "normal");
  pdf.setTextColor(0, 0, 0);

  // Filters box
  pdf.setFillColor(...hexToRGB(COLORS.backgrounds.highlight));
  pdf.roundedRect(20, 60, pdf.internal.pageSize.width - 40, 20, 3, 3, "F");
  pdf.setTextColor(0, 0, 0);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(10);

  const pageWidth = 210; // standard A4 width in mm
  const margin = 20;
  const maxWidth = pageWidth - 2 * margin;
  const subheading = `Performance Report for ${formatName("product", productDetails, product)} - ${formatName("apiType", endpointTypeDetails, apiType)} across ${formatName("environment", environmentDetails, environment)} Environments, Managed by ${formatName("OEM", oemDetails, oem)}`;
  // What's This Report About section
  const wrappedHeading = pdf.splitTextToSize(subheading, maxWidth - 10);
  pdf.text(wrappedHeading, 25, 67);
  // What's This Report About section
  pdf.setFont("helvetica", "bold");
  pdf.text("What's This Report About?", 20, 90);

  pdf.setFont("helvetica", "normal");
  const reportDescription = `This report provides a critical analysis of our system's endpoint performance, offering insights into operational reliability and service availability.`;

  // Use splitTextToSize to wrap text
  const wrappedText = pdf.splitTextToSize(reportDescription, maxWidth);
  pdf.text(wrappedText, 20, 100);

  // Main Points section
  pdf.setFont("helvetica", "bold");
  pdf.text("Main Points:", 20, 120);

  pdf.setFont("helvetica", "normal");
  const leastAvailable = data.overallResults.sort(
    (a, b) => a.availabilityPercentage - b.availabilityPercentage
  )[0];

  const mostAvailable = data.overallResults.sort(
    (a, b) => b.availabilityPercentage - a.availabilityPercentage
  )[0];

  pdf.text(
    `• Least Available: ${leastAvailable.endpoint} (${leastAvailable.availabilityPercentage.toFixed(2)}%)`,
    20,
    130
  );
  pdf.text(
    `• Most Available: ${mostAvailable.endpoint} (${mostAvailable.availabilityPercentage.toFixed(2)}%)`,
    20,
    140
  );
  // Reset font for subsequent content
  pdf.setFont("helvetica", "normal");
  // Define card dimensions and spacing
  const cardWidth = 80;
  const cardHeight = 50;
  const cardSpacing = 10;
  const startY = 150;
  const leftMargin = 20;

  // Draw card shadows (optional - for better visibility)
  pdf.setDrawColor(200, 200, 200);
  pdf.setLineWidth(0.1);

  // First Row - Left Card (Active Endpoints)
  pdf.setFillColor(...hexToRGB(COLORS.backgrounds.card));
  pdf.roundedRect(leftMargin, startY, cardWidth, cardHeight, 3, 3, "FD");
  const latestTimestamp = data.overallResults.reduce((latest, endpoint) => {
    const currentTimestamp = new Date(endpoint.latestTimestamp);
    const latestTimestamp = new Date(latest);
    return currentTimestamp > latestTimestamp ? endpoint.latestTimestamp : latest;
  }, data.overallResults[0]?.latestTimestamp || '');

  const latestDate = new Date(latestTimestamp).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
  // Center main heading "Active endpoints"
  pdf.setFontSize(12);
  pdf.setTextColor(0, 0, 0);
  const headingText = "Active endpoints ";
  pdf.text(headingText, leftMargin + 20, startY - 1 + 15);

  // Date text with lighter color and smaller size on same line
  pdf.setFontSize(9);
  pdf.setTextColor(150, 150, 150); // Light grey color
  const headingTextWidth = pdf.getStringUnitWidth(headingText) * 12 * 0.352778;
  const dateText = `(${latestDate})`;
  pdf.text(dateText, leftMargin + 20 + headingTextWidth, startY - 1 + 15);

  // Add vertical dividing line
  pdf.setDrawColor(220, 220, 220);
  pdf.setLineWidth(0.5);
  pdf.line(
    leftMargin + cardWidth / 2,
    startY + 22,
    leftMargin + cardWidth / 2,
    startY + 42
  );

  // Running endpoints section
  pdf.setTextColor(0, 128, 0);

  // Center "Running" subheading in left half
  pdf.setFontSize(8);
  const runningText = "Running";
  const runningWidth = pdf.getStringUnitWidth(runningText) * 8 * 0.352778;
  const runningX = leftMargin + (cardWidth / 2 - runningWidth) / 2;
  pdf.text(runningText, runningX, startY + 25);

  // Center running count in left half
  pdf.setFontSize(20);
  const runningCountWidth =
    pdf.getStringUnitWidth(`${runningEndpoints}`) * 20 * 0.352778;
  const runningCountX = leftMargin + (cardWidth / 2 - runningCountWidth) / 2;
  pdf.text(`${runningEndpoints}`, runningCountX, startY + 40);

  // Failed endpoints section
  pdf.setTextColor(255, 0, 0);
  const failedEndpoints = data.overallResults.filter(
    (item) => item.latestStatus !== "Running"
  ).length;

  // Center "Failed" subheading in right half
  pdf.setFontSize(8);
  const failedText = "Failed";
  const failedWidth = pdf.getStringUnitWidth(failedText) * 8 * 0.352778;
  const failedX =
    leftMargin + cardWidth / 2 + (cardWidth / 2 - failedWidth) / 2;
  pdf.text(failedText, failedX, startY + 25);

  // Center failed count in right half
  pdf.setFontSize(20);
  const failedCountWidth =
    pdf.getStringUnitWidth(`${failedEndpoints}`) * 20 * 0.352778;
  const failedCountX =
    leftMargin + cardWidth / 2 + (cardWidth / 2 - failedCountWidth) / 2;
  pdf.text(`${failedEndpoints}`, failedCountX, startY + 40);

  // First Row - Right Card (Availability)
  const rightCardX = leftMargin + cardWidth + cardSpacing;
  pdf.setFillColor(...hexToRGB(COLORS.backgrounds.accent));
  pdf.roundedRect(rightCardX, startY, cardWidth, cardHeight, 3, 3, "FD");

  // Main heading "Availability"
  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(12);
  const availText = "Availability";
  const availWidth = pdf.getStringUnitWidth(availText) * 12 * 0.352778;
  const availX = rightCardX + (cardWidth - availWidth) / 2;
  pdf.text(availText, availX, startY + 15);

  // Smaller descriptive text
  pdf.setFontSize(8);
  const descText = "Average availability of all running endpoints";
  pdf.text(descText, rightCardX + 10, startY + 20);

  // Add horizontal line
  pdf.setDrawColor(220, 220, 220); // Light grey color for the line
  pdf.setLineWidth(0.5);
  pdf.line(
    rightCardX + 10, // Start 10mm from left edge of card
    startY + 22, // Position it 2mm below the subtitle text
    rightCardX + cardWidth - 10, // End 10mm from right edge of card
    startY + 22 // Same Y position as start
  );

  // Centered Availability percentage
  pdf.setTextColor(46, 174, 52);
  pdf.setFontSize(20);
  const percentageText = `${overallAvailability}`;
  const percentageWidth =
    pdf.getStringUnitWidth(percentageText) * 20 * 0.352778;
  const percentageX = rightCardX + (cardWidth - percentageWidth) / 2;
  pdf.text(percentageText, percentageX, startY + 36);
  // Second Row - Left Card (Least Available)
  const secondRowY = startY + cardHeight + cardSpacing;
  pdf.setFillColor(...hexToRGB(COLORS.backgrounds.highlight));
  pdf.roundedRect(
    leftMargin,
    secondRowY,
    cardWidth,
    cardHeight + 15,
    3,
    3,
    "FD"
  ); // Increased height for table
  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(10); // Reduced heading size
  pdf.text("Least Available", leftMargin + 28, secondRowY + 15);
  pdf.setFontSize(8);
  // pdf.text(`In the last ${duration}`, leftMargin + 28, secondRowY + 20);
  pdf.text(formatDurationText(duration), leftMargin + 28, secondRowY + 20);
  // Static table data
  pdf.autoTable({
    startY: secondRowY + 30,
    margin: { left: leftMargin + 0 },
    head: [["Endpoint", "Success%"]],
    body: data.overallResults
      .map((item) => [
        item.endpoint,
        `${item.availabilityPercentage.toFixed(2)}%`,
        item.availabilityPercentage, // Keep the numerical value for sorting
      ])
      .sort((a, b) => a[2] - b[2]) // Sort by the numerical value
      .slice(0, 2)
      .map(([endpoint, percentage]) => [endpoint, percentage]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineColor: [240, 240, 240],
      lineWidth: 0.1,
      fillColor: [...hexToRGB(COLORS.backgrounds.card)], // White background
    },
    headStyles: {
      fillColor: [...hexToRGB(COLORS.backgrounds.card)], // Light blue background
      textColor: [...hexToRGB(COLORS.primary)], // Navy blue text
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [...hexToRGB(COLORS.backgrounds.page)], // Light blue-grey for alternate rows
    },
    columnStyles: {
      0: { cellWidth: 50 },
      1: { cellWidth: 30 },
    },
  });
  // Second Row - Right Card (Failures)
  pdf.setFillColor(255, 255, 255);
  pdf.roundedRect(rightCardX, secondRowY, cardWidth, cardHeight, 3, 3, "FD");
  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(12);
  const failuresText = "Failures";
  const failuresWidth = pdf.getStringUnitWidth(failuresText) * 12 * 0.352778;
  const failuresX = rightCardX + (cardWidth - failuresWidth) / 2;
  pdf.text(failuresText, failuresX, secondRowY + 15);

  pdf.setFontSize(8);
  pdf.text(
    "Failures recorded in the past month",
    rightCardX + 18,
    secondRowY + 20
  );

  // Add horizontal line
  pdf.setDrawColor(220, 220, 220); // Light grey color for the line
  pdf.setLineWidth(0.5);
  pdf.line(
    rightCardX + 10, // Start 10mm from left edge of card
    secondRowY + 22, // Position it 2mm below the subtitle text
    rightCardX + cardWidth - 10, // End 10mm from right edge of card
    secondRowY + 22 // Same Y position as start
  );

  pdf.setTextColor(255, 0, 0);
  pdf.setFontSize(20);
  const failures = `${totalFailures}`;
  const failuresCountWidth = pdf.getStringUnitWidth(failures) * 20 * 0.352778;
  const failuresCountX = rightCardX + (cardWidth - failuresCountWidth) / 2;
  pdf.text(failures, failuresCountX, secondRowY + 36);
  // Graph configuration
  pdf.addPage();
  const graphWidth = pdf.internal.pageSize.width - 40;
  const graphHeight = 150;
  const graphMarginLeft = 30;
  const graphMarginBottom = 30;
  const graphMarginTop = 10;

  const graphStartY = 30;

  // Calculate date range for x-axis
  const allDates = data.graphresultsArray[0].averagePerDayData.map(
    (d) => new Date(d.timeInterval)
  );

  // Determine number of x-axis labels based on duration
  let dateInterval;
  let dateFormat;
  if (duration === "7days") {
    dateInterval = 1; // Show every day
    dateFormat = (date) =>
      date.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
  } else if (duration === "1month") {
    dateInterval = 7; // Show weekly
    dateFormat = (date) =>
      date.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
  } else {
    dateInterval = 14; // Show bi-weekly for longer duration
    dateFormat = (date) =>
      date.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
  }

  // Graph title
  pdf.setTextColor(0, 51, 102); // #003366
  pdf.setFontSize(16);
  pdf.setFont("helvetica", "bold");
  pdf.text("Success % Average Graph", leftMargin, graphStartY);

  // Draw graph container
  pdf.setFillColor(255, 255, 255);
  pdf.roundedRect(
    leftMargin,
    graphStartY + 5,
    graphWidth,
    graphHeight,
    3,
    3,
    "FD"
  );

  // Create grid lines
  pdf.setDrawColor(240, 240, 240);
  pdf.setLineWidth(0.2);
  [0, 25, 50, 75, 100].forEach((value) => {
    const y =
      graphStartY +
      graphHeight -
      graphMarginBottom -
      (value * (graphHeight - graphMarginBottom - graphMarginTop)) / 100;
    pdf.line(leftMargin + graphMarginLeft, y, leftMargin + graphWidth - 10, y);
  });

  // Draw axes
  pdf.setDrawColor(200, 200, 200);
  pdf.setLineWidth(0.3);

  // Y-axis
  pdf.line(
    leftMargin + graphMarginLeft,
    graphStartY + graphMarginTop,
    leftMargin + graphMarginLeft,
    graphStartY + graphHeight - graphMarginBottom
  );

  // X-axis
  pdf.line(
    leftMargin + graphMarginLeft,
    graphStartY + graphHeight - graphMarginBottom,
    leftMargin + graphWidth - 10,
    graphStartY + graphHeight - graphMarginBottom
  );

  // Modern color palette
  const colors = [
    "#003366",
    "#FFD770",
    "#0066CC",
    "#FFB347",
    "#3399FF",
    "#FFAA00",
    "#66B2FF",
    "#FF9933",
    "#99CCFF",
    "#FFCC66",
  ];

  // Plot data lines
  data.graphresultsArray.forEach((endpoint, index) => {
    const color = colors[index % colors.length];
    pdf.setDrawColor(...hexToRGB(color));
    pdf.setLineWidth(0.8);

    const points = endpoint.averagePerDayData;
    const xScale = (graphWidth - graphMarginLeft - 20) / (points.length - 1);
    const yScale = (graphHeight - graphMarginBottom - graphMarginTop) / 100;

    points.forEach((point, i) => {
      if (i < points.length - 1) {
        const x1 = leftMargin + graphMarginLeft + i * xScale;
        const y1 =
          graphStartY +
          graphHeight -
          graphMarginBottom -
          point.avgAvailability * yScale;
        const x2 = leftMargin + graphMarginLeft + (i + 1) * xScale;
        const y2 =
          graphStartY +
          graphHeight -
          graphMarginBottom -
          points[i + 1].avgAvailability * yScale;
        pdf.line(x1, y1, x2, y2);

        // Add small dots at data points
        pdf.setFillColor(...hexToRGB(color));
        pdf.circle(x1, y1, 0.5, "F");
        if (i === points.length - 2) {
          pdf.circle(x2, y2, 0.5, "F");
        }
      }
    });
  });

  // Add Y-axis labels
  pdf.setFontSize(8);
  pdf.setTextColor(100, 100, 100);
  [0, 25, 50, 75, 100].forEach((value) => {
    const y =
      graphStartY +
      graphHeight -
      graphMarginBottom -
      (value * (graphHeight - graphMarginBottom - graphMarginTop)) / 100;
    pdf.text(`${value}%`, leftMargin + 5, y + 2);
  });

  // Add X-axis dates
  pdf.setFontSize(7);
  pdf.setTextColor(100, 100, 100);
  allDates.forEach((date, i) => {
    if (i % dateInterval === 0) {
      const x =
        leftMargin +
        graphMarginLeft +
        (i * (graphWidth - graphMarginLeft - 20)) /
        (allDates.length > 1 ? allDates.length - 1 : 1);
      const formattedDate = dateFormat(date);
      pdf.text(formattedDate, x - 8, graphStartY + graphHeight - 5, {
        angle: 45,
      });
    }
  });

  const legendStartY = graphStartY + graphHeight + 15;
  const legendBoxPadding = 5;
  const legendItemHeight = 12;
  const maxColumns = 3;
  const maxRows = 4;
  const legendColumnWidth = 55;

  // Calculate legend box dimensions
  const legendBoxWidth = legendColumnWidth * maxColumns + legendBoxPadding * 2;
  const legendBoxHeight =
    Math.min(maxRows, Math.ceil(data.graphresultsArray.length / maxColumns)) *
    legendItemHeight +
    legendBoxPadding * 2;

  // Draw legend box
  pdf.setFillColor(...hexToRGB(COLORS.backgrounds.highlight));
  pdf.roundedRect(
    leftMargin,
    legendStartY,
    legendBoxWidth,
    legendBoxHeight,
    2,
    2,
    "F"
  );

  // Add legend items
  data.graphresultsArray.forEach((endpoint, index) => {
    if (index >= maxColumns * maxRows) {
      if (index === maxColumns * maxRows) {
        const xPosition = leftMargin + legendBoxPadding;
        const yPosition =
          legendStartY + legendBoxPadding + maxRows * legendItemHeight;
        pdf.setTextColor(60, 60, 60);
        pdf.setFontSize(6);
        pdf.text("...", xPosition, yPosition);
      }
      return;
    }

    const color = colors[index % colors.length];
    const columnIndex = index % maxColumns;
    const rowIndex = Math.floor(index / maxColumns);

    const xPosition =
      leftMargin + legendBoxPadding + columnIndex * legendColumnWidth;
    const yPosition =
      legendStartY + legendBoxPadding + rowIndex * legendItemHeight;

    //Draw a color line
    pdf.setDrawColor(...hexToRGB(color));
    pdf.setLineWidth(1.5);
    pdf.line(xPosition, yPosition + 4, xPosition + 10, yPosition + 4);

    // Add endpoint name with strict truncation
    pdf.setTextColor(60, 60, 60);
    pdf.setFontSize(6);
    const maxNameLength = 20; // Adjust this value to fit your legend box width
    const endpointName =
      endpoint.endpointName.length > maxNameLength
        ? endpoint.endpointName
        : endpoint.endpointName;
    pdf.text(endpointName, xPosition + 12, yPosition + 5);
  });
  // Adjust legend box height if fewer than 4 rows are used
  const actualRows = Math.min(
    maxRows,
    Math.ceil(data.graphresultsArray.length / maxColumns)
  );
  const adjustedLegendBoxHeight =
    actualRows * legendItemHeight + legendBoxPadding * 2;

  pdf.addPage();

  const tableStartY = 30;

  // Add "Endpoint Details" heading
  pdf.setFontSize(14);
  pdf.setFont("helvetica", "bold");
  pdf.text("Endpoint Details", leftMargin, tableStartY);
  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");
  const formattedProductDescription = formatProductDescription(productDescription);
  const description = `This table provides comprehensive availability metrics for all monitored endpoints across our system infrastructure. It covers the availability details of portal, authentication, and health APIs for ${formattedProductDescription} services.`;
  const wrappedDescription = pdf.splitTextToSize(description, pageWidth - 2 * leftMargin);
  pdf.text(wrappedDescription, leftMargin, tableStartY + 8);
  // Add Endpoint Details table
  pdf.autoTable({
    startY: tableStartY + 20,
    head: [["Endpoint", "Success%", "Failure Count", "Latest Run", "Status"]],
    body: data.overallResults
      .map((item) => [
        item.endpoint,
        `${item.availabilityPercentage.toFixed(2)}%`,
        item.downRequests,
        item.latestTimestamp,
        item.latestStatus,
      ])
      .sort((a, b) => parseFloat(a[1]) - parseFloat(b[1])),
    styles: {
      fontSize: 10,
      cellPadding: 5,
      lineColor: [240, 240, 240],
      lineWidth: 0.1,
      fillColor: [...hexToRGB(COLORS.backgrounds.card)],
    },
    headStyles: {
      fillColor: [...hexToRGB(COLORS.backgrounds.highlight)],
      textColor: [...hexToRGB(COLORS.primary)],
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [...hexToRGB(COLORS.backgrounds.page)],
    },
    columnStyles: {
      0: { cellWidth: 50 },
      1: { cellWidth: 30 },
      2: { cellWidth: 30 },
      3: { cellWidth: 40 },
      4: { cellWidth: 30 },
    },
  });
  const pageCount = pdf.internal.getNumberOfPages();
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8);
  pdf.setTextColor(...hexToRGB(COLORS.text.muted));
  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);
    const timestamp = new Date().toLocaleString();
    pdf.text(
      `Generated by CloudLens on ${timestamp}`,
      margin + 5,
      pdf.internal.pageSize.height - 10
    );
    pdf.text(
      `Page ${i} of ${pageCount}`,
      pageWidth - (margin + 5),
      pdf.internal.pageSize.height - 10,
      { align: "right" }
    );
  }

  pdf.save("EndpointAvailabilityReport.pdf");
}
const getMainpageData = async (
  oem,
  product,
  environment,
  apiType,
  duration,
  apiUrl,
  accessToken
) => {
  const query = `
      query GetMainEndpointPageDetails($duration: String!, $apiType: String!, $environment: String!, $oem: String!, $product: String!) {
        getMainEndpointPageDetails(duration: $duration, filters: {ApiType: $apiType, Environment: $environment, OemName: $oem, ProductName: $product}) {
          graphresultsArray {
            endpointName
             averagePerDayData{
              avgAvailability
              timeInterval
            }
          }
          overallAvailability
          overallResults {
            availabilityPercentage
            downRequests
            endpoint
            latestStatus
            latestTimestamp
            totalRequests
          }
        }
      }
    `;
  const response = await axios.post(
    apiUrl,
    {
      query,
      variables: {
        duration,
        environment,
        apiType,
        oem,
        product,
      },
    },
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  return response.data.data.getMainEndpointPageDetails;
};
function hexToRGB(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return [r, g, b];
}

const formatName = (type, descriptions, value) => {
  return value === "all"
    ? Object.keys(descriptions)
      .map((key) => descriptions[key])
      .join(", ")
    : descriptions[value] || value;
};

function formatDurationText(duration) {
  const monthYearPattern = /^(\d{2})-(\d{4})$/;
  const match = duration.match(monthYearPattern);
  if (match) {
    const [, month, year] = match;
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthIndex = parseInt(month) - 1;
    return `In ${monthNames[monthIndex]} ${year}`;
  }
  const durationMap = {
    '7days': 'In the last 7 days',
    '1Month': 'In the last month',
    '3months': 'In the last 3 months',
  };
  return durationMap[duration] || `In the last ${duration}`;
}
function formatProductDescription(productDescription) {
  if (!productDescription || productDescription.trim() === '') {
    return '';
  }
  const items = productDescription.split(',').map(item => item.trim()).filter(item => item !== '');
  if (items.length === 1) {
    return items[0];
  } else if (items.length === 2) {
    return `${items[0]} and ${items[1]}`;
  } else if (items.length > 2) {
    const allButLast = items.slice(0, -1);
    const lastItem = items[items.length - 1];
    return `${allButLast.join(', ')}, and ${lastItem}`;
  }

  return productDescription;
}